import Vue from 'vue'

const BASE_URL = 'admins';


const showError = (error, defaultMessage) => {
  const serverMessage = error && error.response && error.response.data[0] && error.response.data[0].message;
  Vue.prototype.$swal.fire('Error', serverMessage ? serverMessage : defaultMessage);
}

const getAdmins = (query) => {
  const url = `${BASE_URL}?${query}`;

  return Vue.prototype.$http.get(url)
    .then(response => response.data)
    .catch(err => showError(err, 'Failed to load admins'));
};

const createAdmin = (data) => {
  return Vue.prototype.$http.post(BASE_URL, data)
    .catch(err => showError(err, 'Failed to create admin'));
};

const updateAdmin = (adminId, data) => {
  const url = `${BASE_URL}/${adminId}`;

  return Vue.prototype.$http.patch(url, data)
    .catch(err => showError(err, 'Failed to update admin'));
};


const deleteAdmin = (adminId) => {
  const url = `${BASE_URL}/${adminId}`;

  return Vue.prototype.$http.delete(url)
    .catch(err => showError(err, 'Failed to delete admin'));
};

const getAdminById = (adminId) => {
  const url = `${BASE_URL}/${adminId}`;

  return Vue.prototype.$http.get(url)
    .then(response => response.data)
    .catch(err => showError(err, 'Failed to get admin'));
};

export {
  getAdmins,
  createAdmin,
  updateAdmin,
  deleteAdmin,
  getAdminById,
};
